module.exports = __webpack_public_path__ + "f3f047ed4fdc9bb53a8d8144c559ea15.png";